import BaseModal from "components/BaseModal";
import { useSession } from "hooks/useSession";
import { useState, useEffect } from "react";
import React from "react";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";

export default function UserFormModal({ show, onClose, mode, userData, onSuccess,userRole }) {
  console.log(userData);
  const { userid } = useSession();

  
  
  const isPlatformUser = (userRole || "").trim().toLowerCase() === "platform user";
  const [canMemberEdit, setCanMemberEdit] = useState(false);
 
  useEffect(() => {
    if (!isPlatformUser) return;
    const fd = new FormData();
    fd.append("action", "GET_MY_MODULES");
    fetchWrapper("https://pro.mokshiq.in/platform_user_action", {
      method: "POST",
      body: fd,
    })
      .then((res) => {
        if (res?.status) setCanMemberEdit(!!res.data?.can_member_edit);
      })
      .catch(() => {});
  }, [isPlatformUser]);
 
  // API Partner can be created by:
  //  - Admin / Main Admin directly, or
  //  - a Platform User who has been granted member-edit permission by their creator
  const canCreateApiPartner =
    userRole === "Admin" ||
    userRole === "Main Admin" ||
    (isPlatformUser && canMemberEdit);
  const handleSave = async () => {
    const name  = document.getElementById("name").value;
    const email = document.getElementById("email").value;
    const phone = document.getElementById("phone").value;
    const role  = document.querySelector('select[name="role"]').value;

    const formData = new FormData();
    formData.append("name",   name);
    formData.append("email",  email);
    formData.append("phone",  phone);
    formData.append("role",   role);
    formData.append("userid", userid);
    formData.append("action", "ADDUpdate");
    formData.append("id",     userData?.id || "");

    try {
      const response = await fetch("https://pro.mokshiq.in/retailer_action", {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        body: formData,
      });

      if (!response.ok) {
        showMainToast("Something went wrong!", "danger");
        return;
      }

      const result = await response.json();
      if (result.status) {
        showMainToast(result.data || "Success!", "success");
        onClose();
        if (onSuccess) onSuccess();
      } else {
        showMainToast(result.data || "Something went wrong!", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={mode === "edit" ? "Edit Member" : "Add Member"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        {
          label: mode === "edit" ? "Update" : "Save",
          className: "btn-primary",
          onClick: handleSave,
        },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="form-validation">
          <div className="col-md-6">
            <label className="form-label" htmlFor="name">Name</label>
            <input
              className="form-control"
              id="name"
              name="name"
              type="text"
              defaultValue={userData?.name || ""}
            />
            <div className="mt-1"><span className="text-danger" id="userNameError"></span></div>
          </div>

          <div className="col-md-6">
            <label className="form-label" htmlFor="email">Email</label>
            <input
              className="form-control"
              id="email"
              type="email"
              defaultValue={userData?.email || userData?.Email || ""}
            />
            <div className="mt-1"><span className="text-danger" id="emailError"></span></div>
          </div>

          <div className="col-md-6">
            <label className="form-label" htmlFor="phone">Phone</label>
            <input
              className="form-control"
              id="phone"
              type="text"
              defaultValue={userData?.phone || userData?.Phone || ""}
            />
            <div className="mt-1"><span className="text-danger" id="phoneError"></span></div>
          </div>

          <div className="col-md-6">
            <label className="form-label">Role</label>
            <select
              className="form-select w-100"
              name="role"
              defaultValue={userData?.role || "5"}
            >
              <option value="5">Retailer</option>
              <option value="4">Distributor</option>
              <option value="3">Super Distributor</option>
              <option value="2">White label</option>
              {canCreateApiPartner && <option value="9">API Partner</option>}
            </select>
            <div className="mt-1"><span className="text-danger" id="roleError"></span></div>
          </div>
        </form>
      </div>
    </BaseModal>
  );
}